export const createIdempotencyKey = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random()}`;

export const idempotencyConfig = () => ({
  headers: { 'Idempotency-Key': createIdempotencyKey() },
});
